<div class="fill-height p-2 d-flex justify-content-center">
  <div *ngIf="isLoading" class="d-flex h-100 align-items-center justify-content-center">
    <mat-spinner class="zx-small-icon-size"></mat-spinner>
  </div>
  <!-- orders -------------------------------------------------------------------------------------------------------- orders -->
  <div *ngIf="!isLoading" class="w-100 flex-grow-1 d-flex flex-column align-items-center justify-content-center gap-3">

    <h6 *ngIf="orderStatus === 'PENDING'">
      {{ "pending-order.title" | translate }}
    </h6>

    <h6 *ngIf="orderStatus === 'PROCESSING'">
      {{ "error-title-ORDER_ALREADY_IN_QUEUE" | translate }}
    </h6>

    <h6 *ngIf="orderStatus === 'DONE'">
      {{ "my-orders.order-printed" | translate }}
    </h6>

    <h6 *ngIf="orderStatus === 'EXPIRED'">
      {{ "my-orders.order-expired" | translate }}
    </h6>

    <h6 *ngIf="orderStatus === 'REFUNDED' ||
         orderStatus === 'REFUNDED_POINTS' ||
         orderStatus === 'CANCELLED'">
      {{ "my-orders.order-refunded" | translate }}
    </h6>

    <h6 *ngIf="orderStatus === 'REFUNDED'">
      {{ "my-orders.order-refunded-explain" | translate }}
    </h6>

    <h6 *ngIf="orderStatus === 'REFUNDED_POINTS'">
      {{ "my-orders.order-refunded-explain.points" | translate }}
    </h6>

    <h6 *ngIf="orderStatus === 'ERROR'">
      {{ "su-management.order-with-error" | translate }}
    </h6>
    <h6 *ngIf="orderStatus === 'ERROR'">
      {{ "order-complited.printed.title.sub.problme-btn" | translate }}
    </h6>

    <button class="rounded-pill text-white" mat-raised-button color="primary" type="button" (click)="openOrderSummary()"
      [disabled]="orderStatus !== 'PENDING'">
      {{ "my-profile.go-to-order-one" | translate }}
    </button>

    <!-- created  order.addedToQueue-->
    <span class="zx-text-tiny zx-text-sm-small opacity-75 pt-2">
      <span>
        {{ "my-orders.created" | translate }}
      </span>
      <span>
        {{ "my-orders.at" | translate }}
      </span>
      <span>
        {{ order.created | date:'HH:mm' }}
      </span>
      <span>
        {{ "my-orders.at" | translate }}
      </span>
      <span>
        {{ order.created | date:'dd/MM/yy' }}
      </span>
    </span>
    <!-- // created -->

  </div>
</div>

<div class="p-2 d-flex flex-column">
  <div class="pt-2">
    <button *ngIf="orderStatus === 'PENDING'" class="w-100 rounded-pill fw-bold text-green" mat-flat-button
      type="button" (click)="goToNewOrder()">
      {{ "main-nav.new-order" | translate }}
    </button>
    <button *ngIf="orderStatus !== 'PENDING'" class="w-100 rounded-pill fw-bold text-white" mat-raised-button
      type="button" color="primary" (click)="goToNewOrder()">
      {{ "main-nav.new-order" | translate }}
    </button>
  </div>
</div>